export const calculateOwnership = (value: number, ownership: number) =>
  (value * ownership) / 100;
